var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2370 5113 c-371 -35 -653 -114 -961 -269 -406 -203 -782 -548 -1029 -944 -179 -286 -309 -655 -362 -1025 -17 -118 -17 -512 0 -630 42 -295 120 -553 242 -800 137 -280 272 -468 494 -691 221 -220 412 -357 681 -489 188 -92 309 -137 500 -185 500 -126 1002 -102 1490 71 149 53 407 182 540 271 365 243 667 578 866 963 181 348 271 694 286 1090 15 426 -73 832 -263 1214 -124 250 -263 447 -458 648 -216 224 -428 378 -711 518 -296 146 -572 225 -900 255 -102 9 -333 11 -415 3z m1225 -1114 c210 -65 354 -214 406 -419 21 -81 21 -1959 0 -2040 -53 -211 -210 -368 -421 -421 -45 -12 -229 -14 -1025 -14 l-970 0 -79 24 c-218 68 -366 245 -396 474 -12 94 -12 1820 0 1914 34 260 228 458 485 493 33 4 485 7 1005 6 820 -2 952 -4 995 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3190 3435 l0 -245 245 0 245 0 0 245 0 245 -245 0 -245 0 0 -245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 3051 c-131 -42 -233 -120 -295 -226 -177 -300 -24 -673 312 -760 268 -70 547 97 618 372 53 203 -35 431 -211 548 -119 79 -297 107 -424 66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 2233 l0 -628 24 -50 c30 -65 78 -112 142 -142 l52 -23 963 2 964 3 41 22 c53 28 99 74 127 127 22 41 22 42 25 679 l3 637 -217 0 c-202 0 -216 -1 -209 -17 52 -131 63 -338 26 -478 -96 -361 -400 -596 -771 -597 -370 -1 -675 236 -771 597 -37 140 -26 347 26 478 7 16 -7 17 -209 17 l-216 0 0 -627z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.134ba1235eb6b557cee00ec0c30e9c2e.svg";
export { ForwardRef as ReactComponent };